import styled from "styled-components";

import { SmallPrint } from "features/shared/styles/typography/SmallPrint.styled";

const StyledCardError = styled.div`
  display: flex;
  align-items: center;

  img {
    margin-right: 8px;
  }

  ${SmallPrint} {
    color: ${({ theme }) => theme.colors.highlight3};
  }
`;

export default StyledCardError;
